/**
 * PlaceCoreDidYouKnow — "Att veta"
 * Lens-compatible: quiet aside, never alert-like.
 */
import { useTranslate } from "@/i18n";

interface Props {
  text: string;
}

export function PlaceCoreDidYouKnow({ text }: Props) {
  const t = useTranslate();
  return (
    <div className="rounded-xl bg-muted/30 p-4 sm:p-5">
      <p className="text-xs font-medium text-muted-foreground mb-1.5 tracking-wide">
        {t("place.didYouKnow.label")}
      </p>
      <p className="text-sm text-foreground/75 leading-relaxed">{text}</p>
    </div>
  );
}
